import React from 'react';
import { SocialMediaEnum } from 'utils/enums';
import FacebookIcon from '../../assets/icons/facebook.svg';
import InstagramIcon from '../../assets/icons/instagram.svg';
import TikTokIcon from '../../assets/icons/tiktok.svg';
import YoutubeIcon from '../../assets/icons/youtube.svg';

type SocialMediaProps = {
  type: SocialMediaEnum,
  link: string,
  iconClass?: string
};

const getIcon = (type: SocialMediaEnum) => {
  switch (type) {
    case SocialMediaEnum.Facebook:
      return <FacebookIcon />;
    case SocialMediaEnum.Instagram:
      return <InstagramIcon />;
    case SocialMediaEnum.TikTok:
      return <TikTokIcon />;
    case SocialMediaEnum.YouTube:
      return <YoutubeIcon />;
    default:
      return null;
  }
};

const SocialMedia = ({
  type, link, iconClass,
}: SocialMediaProps) => (
  <a className={iconClass} href={link} aria-label={type}>{getIcon(type)}</a>
);

export { SocialMedia };
